/**
 * Linked to coast/block/gms-widget-login.html specific code
 * Add the parameter ?coast_gp_redirect=???? to the URL of some links
 * To have the ability to be redirected to the current page after login
 */


export default function(container) {
	$('.js-has-gms-redirection', container).attr('href', function(index, currentValue){
		if (currentValue.indexOf('coast_gp_redirect') > -1) return currentValue;
		return currentValue + '?coast_gp_redirect=' + document.location.pathname;
	});
}
